import { SEARCH_TERM_CHANGED } from "./action_types"

export type SEARCH_TERM_CHANGED_ACTION = {
    type: typeof SEARCH_TERM_CHANGED
    search_term: string
}

export const setSearchTerm = (searchTerm: string): SEARCH_TERM_CHANGED_ACTION => ({
    type: SEARCH_TERM_CHANGED,
    search_term: searchTerm,
})
